<div class="modal-header">
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>

<div class="modal-body distribution-preview-body">
    <iframe
        *ngIf="pdfUrl"
        [src]="pdfUrl"
        title="Vista previa del PDF">
    </iframe>
</div>
